import React, { useEffect } from 'react';
import {CareerNames} from "jobjump-types/Careers";
import Careers from "../data/Careers";
import {Row, Col} from "../components/grid";
import stripHtml from "string-strip-html";
import CareerImages from "../assets/CareerImages";
import FilterableGrid from '../components/FilterableGrid';
import Modal from '../components/Modal';
import { RouteComponentProps } from 'react-router';
import ContentWrapper from '../components/ContentWrapper';
import { CareerSubjectRecommendation } from 'jobjump-types/Subjects';
import Subjects from '../data/Subjects';

const stringOfSubjectRecommendation = (s:CareerSubjectRecommendation) => {
    const list = !s.additional_subjects ? "" : (s.additional_subjects.length === 1 ? s.additional_subjects[0] : 
        [s.additional_subjects.slice(0, -1).join(', '), s.additional_subjects.slice(-1)[0]].join(s.additional_subjects.length < 2 ? '' : ' or '));
 
    if (s.kind === "single") {
        return s.subject_name || "";
    }
    if (s.kind === "option") {
        return `${s.content||""} ${list}`; 
    }
    if (s.kind === "scaled") {
        return `${s.subject_name||""} ${s.content||""} (${list})`;
    }
    if (s.kind === "text") {
        return s.content||"";
    }
}

const MySubjects : React.FC<RouteComponentProps<{career?:string}>> =
    (props) => {
        const [career, setCareer] = React.useState<string>();
        const [careerList, setCareerList] = React.useState<CareerNames[]>([]);
        const [subjectText, setSubjectText] = React.useState("");
        const [subjectRecommendations, setSubjectRecommendations] = React.useState<CareerSubjectRecommendation[]>([]);
        const [subjectCareer, setSubjectCareer] = React.useState("");

        const [show, setShow] = React.useState(false);
        const handleClose = () => {setShow(false); setCareer(undefined)};
        const handleShow = () => setShow(true);

        useEffect(() => {
            setCareer(props.match.params.career)
        }, [props.match.params.career])

        useEffect(() => {
            Careers.getCareerList().then((data) => {
                setCareerList(data)
            })
        }, []);
        useEffect(() => {
            if (career && careerList.length > 0) {
                const careerObj = careerList.find(c=>c.id === Number(career));
                if (!careerObj) { return; }
                Subjects.getSubjectsForCareer(career).then(c => {
                    setSubjectRecommendations(c);
                    handleShow();
                });
                Careers.getCareerDetails(Number(career)).then((info) => {
                    const subject = info.careerText.find((e) => e.kind === "subject");   
                    if (!subject || subject.content === "") {
                        setSubjectText("You can study anything that interests you.");
                    } else {
                        setSubjectText(stripHtml(subject.content));
                    }
                    setSubjectCareer(careerObj.name);
                    handleShow();
                });
            }
        }, [career, careerList]);
        return (
            <ContentWrapper 
                    title="Need to figure out what senior subjects to study?"
                    breadcrumbTitle="Subjects"
                    subtitle={["Select a career to find out some possible choices."]} >
                <Row><Col>
                    <FilterableGrid
                        numPerRow={3}
                        data={careerList.map(d => ({
                            imgUrl: CareerImages[d.name.toUpperCase()] || "",
                            text:d.name,
                            onClick: () => {
                                setCareer(String(d.id));
                            }
                        }))}
                    />
                </Col></Row>
                <Modal show={show} onHide={handleClose} size="lg" title={`${subjectCareer} Subject Advice`}>
                    <Row><Col>
                        {subjectRecommendations.length === 0 && <><strong>{subjectText}</strong><br/></>}
                        {subjectRecommendations.length > 0 && <div>
                            <h4>You could study:</h4>
                            <ul>
                                {subjectRecommendations.map((s, i)=><li key={`sub-${i}`}>{stringOfSubjectRecommendation(s)}</li>)}
                            </ul>
                        </div>}
                        <strong>Tips:</strong>
                        <ol>
                            <li>Discuss the subjects you wish to pick with your Careers Adviser, teachers, your parents
                            and also students who have done well in the subject.</li>
                            <li>Find the topics that will be taught in this subject. Do you like most of what you will learn? </li>
                            <li>Remember once you start your senior subjects it can sometimes be hard to change them. Choose what you
                                like and do well in for the next two years.
                            </li>
                        </ol>
                        <>You may be able to study and develop skills in your career through 
                            an EVET or VET course. Check with your Careers 
                            Adviser or Principal if that is possible and your options if you 
                            want an ATAR.</>
                    </Col></Row>
                </Modal>
            </ContentWrapper>
        );
    }

export default MySubjects;
export {stringOfSubjectRecommendation};